import { render, staticRenderFns } from "./UpdateConfig.vue?vue&type=template&id=739635d7&scoped=true&"
import script from "./UpdateConfig.vue?vue&type=script&lang=js&"
export * from "./UpdateConfig.vue?vue&type=script&lang=js&"
import style0 from "./UpdateConfig.vue?vue&type=style&index=0&id=739635d7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739635d7",
  null
  
)

export default component.exports